import type { DayOfWeek, Lesson } from 'services/api';

export const WEEK_DAYS: DayOfWeek[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
];

export const LESSON_NUMBERS: Lesson[] = [
  'FIRST',
  'SECOND',
  'THIRD',
  'FOURTH',
  'FIFTH',
  'SIXTH',
  'SEVENTH',
  'EIGHTH',
];

export const SUBJECT_COLORS: Record<number, { textColor: string; backgroundColor: string }> = {
  3: {
    textColor: '#595AD9',
    backgroundColor: '#595AD933',
  }, // Математика
  5: {
    textColor: '#B24E42',
    backgroundColor: '#FE6F5E33',
  }, // Родной язык и (или) государственный язык республики Российской Федерации
  6: {
    textColor: '#B2418F',
    backgroundColor: '#B2418F33',
  }, // Литературное чтение на родном языке
  7: {
    textColor: '#29660D',
    backgroundColor: '#4CBB1733',
  }, // Окружающий мир
  8: {
    textColor: '#818124',
    backgroundColor: '#F5F5DC',
  }, // Основы религиозных культур и светской этики
  9: {
    textColor: '#4D4B49',
    backgroundColor: '#DBD7D280',
  }, // Изобразительное искусство
  10: {
    textColor: '#665753',
    backgroundColor: '#98817B33',
  }, // Музыка
  11: {
    textColor: '#333333',
    backgroundColor: '#80808033',
  }, // Труд (технология)
  13: {
    textColor: '#EF4444',
    backgroundColor: '#EF444433',
  }, // Русский язык
  14: {
    textColor: '#A855F7',
    backgroundColor: '#A855F733',
  }, // Литературное чтение
  15: {
    textColor: '#C21E56',
    backgroundColor: '#C21E5633',
  }, // Иностранный язык
  16: {
    textColor: '#B24E42',
    backgroundColor: '#FE6F5E33',
  }, // Родной язык и (или) государственный язык республики Российской Федерации
  17: {
    textColor: '#B24E42',
    backgroundColor: '#FE6F5E33',
  }, // Родной язык и (или) государственный язык республики Российской Федерации
  18: {
    textColor: '#B24E42',
    backgroundColor: '#FE6F5E33',
  }, // Родной язык и (или) государственный язык республики Российской Федерации
  19: {
    textColor: '#5D512D',
    backgroundColor: '#C2B28066',
  }, // Физическая культура
  20: {
    textColor: '#EF4444',
    backgroundColor: '#EF444433',
  }, // Русский язык
  21: {
    textColor: '#EC4899',
    backgroundColor: '#EC489933',
  }, // Литература
  22: {
    textColor: '#B24E42',
    backgroundColor: '#FE6F5E33',
  }, // Родной язык и (или) государственный язык республики Российской Федерации
  23: {
    textColor: '#800080',
    backgroundColor: '#80008033',
  }, // Родная литература
  24: {
    textColor: '#C21E56',
    backgroundColor: '#C21E5633',
  }, // Иностранный язык
  25: {
    textColor: '#702963',
    backgroundColor: '#F1DAED',
  }, // Второй иностранный язык
  26: {
    textColor: '#316CCC',
    backgroundColor: '#3B82F633',
  }, // Алгебра
  27: {
    textColor: '#0051FF',
    backgroundColor: '#0051FF33',
  }, // Геометрия
  28: {
    textColor: '#096663',
    backgroundColor: '#15F4EE33',
  }, // Вероятность и статистика
  29: {
    textColor: '#046D80',
    backgroundColor: '#06B6D433',
  }, // Информатика
  30: {
    textColor: '#DB8A00',
    backgroundColor: '#FFA00033',
  }, // История
  31: {
    textColor: '#BF00FF',
    backgroundColor: '#BF00FF33',
  }, // Обществознание
  32: {
    textColor: '#81613E',
    backgroundColor: '#81613E33',
  }, // География
  33: {
    textColor: '#23726A',
    backgroundColor: '#81D8D04D',
  }, // Физика
  34: {
    textColor: '#21624A',
    backgroundColor: '#3EB48933',
  }, // Химия
  35: {
    textColor: '#436602',
    backgroundColor: '#56820333',
  }, // Биология
  36: {
    textColor: '#4D4B49',
    backgroundColor: '#DBD7D280',
  }, // Изобразительное искусство
  37: {
    textColor: '#665753',
    backgroundColor: '#98817B33',
  }, // Музыка
  38: {
    textColor: '#333333',
    backgroundColor: '#80808033',
  }, // Труд (технология)
  39: {
    textColor: '#E56916',
    backgroundColor: '#E5691633',
  }, // Основы духовно-нравственной культуры народов России
  40: {
    textColor: '#5D512D',
    backgroundColor: '#C2B28066',
  }, // Физическая культура
  41: {
    textColor: '#4D4325',
    backgroundColor: '#C2B28040',
  }, // Основы безопасности и защиты Родины
  42: {
    textColor: '#595AD9',
    backgroundColor: '#595AD933',
  }, // Математика
  44: {
    textColor: '#EF4444',
    backgroundColor: '#EF444433',
  }, // Русский язык
  45: {
    textColor: '#EC4899',
    backgroundColor: '#EC489933',
  }, // Литература
  46: {
    textColor: '#FFFFFF',
    backgroundColor: '#EC4899',
  }, // Литература (углубленный уровень)
  47: {
    textColor: '#F73A25',
    backgroundColor: '#FA807233',
  }, // Родной язык
  48: {
    textColor: '#800080',
    backgroundColor: '#80008033',
  }, // Родная литература
  49: {
    textColor: '#C21E56',
    backgroundColor: '#C21E5633',
  }, // Иностранный язык
  50: {
    textColor: '#FFFFFF',
    backgroundColor: '#C21E56',
  }, // Иностранный язык (углубленный уровень)
  51: {
    textColor: '#702963',
    backgroundColor: '#F1DAED',
  }, // Второй иностранный язык
  52: {
    textColor: '#316CCC',
    backgroundColor: '#3B82F633',
  }, // Алгебра
  53: {
    textColor: '#FFFFFF',
    backgroundColor: '#3B82F6',
  }, // Алгебра (углубленный уровень)
  54: {
    textColor: '#0051FF',
    backgroundColor: '#0051FF33',
  }, // Геометрия
  55: {
    textColor: '#FFFFFF',
    backgroundColor: '#0051FF',
  }, // Геометрия (углубленный уровень)
  56: {
    textColor: '#096663',
    backgroundColor: '#15F4EE33',
  }, // Вероятность и статистика
  57: {
    textColor: '#044A49',
    backgroundColor: '#73F8F5',
  }, // Вероятность и статистика (углубленный уровень)
  58: {
    textColor: '#DB8A00',
    backgroundColor: '#FFA00033',
  }, // История
  59: {
    textColor: '#FFFFFF',
    backgroundColor: '#FFA500',
  }, // История (углубленный уровень)
  60: {
    textColor: '#BF00FF',
    backgroundColor: '#BF00FF33',
  }, // Обществознание
  61: {
    textColor: '#FFFFFF',
    backgroundColor: '#BF00FF',
  }, // Обществознание (углубленный уровень)
  62: {
    textColor: '#81613E',
    backgroundColor: '#81613E33',
  }, // География
  63: {
    textColor: '#FFFFFF',
    backgroundColor: '#81613E',
  }, // География (углубленный уровень)
  64: {
    textColor: '#23726A',
    backgroundColor: '#81D8D04D',
  }, // Физика
  65: {
    textColor: '#174C47',
    backgroundColor: '#81D8D0',
  }, // Физика (углубленный уровень)
  66: {
    textColor: '#21624A',
    backgroundColor: '#3EB48933',
  }, // Химия
  67: {
    textColor: '#FFFFFF',
    backgroundColor: '#3EB489',
  }, // Химия (углубленный уровень)
  68: {
    textColor: '#436602',
    backgroundColor: '#56820333',
  }, // Биология
  69: {
    textColor: '#FFFFFF',
    backgroundColor: '#568203',
  }, // Биология (углубленный уровень)
  70: {
    textColor: '#5D512D',
    backgroundColor: '#C2B28066',
  }, // Физическая культура
  71: {
    textColor: '#4D4325',
    backgroundColor: '#C2B28040',
  }, // Основы безопасности и защиты Родины
  73: {
    textColor: '#046D80',
    backgroundColor: '#06B6D433',
  }, // Информатика
  74: {
    textColor: '#FFFFFF',
    backgroundColor: '#06B6D4',
  }, // Информатика (углубленный уровень)
  75: {
    textColor: '#046D80',
    backgroundColor: '#06B6D433',
  }, // Информатика
  76: {
    textColor: '#3D6635',
    backgroundColor: '#74C36533',
  }, // Природоведение
  77: {
    textColor: '#4D4C4B',
    backgroundColor: '#E5E4E28F',
  }, // Мировая художественная культура
  78: {
    textColor: '#000000',
    backgroundColor: '#00000026',
  }, // Черчение
  79: {
    textColor: '#604A37',
    backgroundColor: '#9266444D',
  }, // Основы безопасности жизнедеятельности
  500: {
    textColor: '#000000',
    backgroundColor: '#F5E6E6',
  }, // Индивидуальный проект
};
